import { FC, useEffect, useState } from 'react';
import { GoogleIcon } from 'assets';
import { Button } from 'view/components';
import { storageService } from 'infrastructure/services/StorageService';
import { useAuthGoogleMe } from 'view/pages/auth/hooks/useAuthGoogleMe';

const GoogleLoginButton: FC<{ variant: 'contained' | 'outlined' }> = ({ variant }) => {
  const [isLoading, setIsLoading] = useState(false);

  const { send } = useAuthGoogleMe();

  const handleTokensReceived = async (data: { token: string; refreshToken: string }) => {
    await storageService.setItem('accessToken', data.token);
    await storageService.setItem('refreshToken', data.refreshToken);
    setIsLoading(false);
    setTimeout(() => {
      window.history.pushState(null, '', window.location.href);
    }, 0);
    await send();
  };

  useEffect(() => {
    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;

      if (event.data.type === 'google_auth_tokens') {
        // Обработка токенов
        handleTokensReceived(event.data);
      }
    };

    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, []);

  const handleGoogleLogin = () => {
    setIsLoading(true);
    storageService.removeItem('accessToken');
    storageService.removeItem('refreshToken');

    const authWindow = window.open(
      `${process.env.REACT_APP_API_URL}/api/v1/auth/google`,
      'googleAuth',
      'width=600,height=600,resizable=yes,scrollbars=yes'
    );

    const messageHandler = (event: MessageEvent) => {
      // Важная проверка origin для безопасности!
      if (event.origin !== window.location.origin) return;

      if (event.data.type === 'google_auth_tokens') {
        // Сохраняем токены в основном окне
        storageService.setItem('accessToken', event.data.token);
        storageService.setItem('refreshToken', event.data.refreshToken);

        // Закрываем popup если он еще открыт
        authWindow?.close();
        setIsLoading(false);
      }

      if (event.data.type === 'google_auth_error') {
        console.error('Ошибка авторизации:', event.data.error);
        authWindow?.close();
        setIsLoading(false);
      }
    };

    window.addEventListener('message', messageHandler);

    // Фолбек на случай если окно было закрыто без сообщения
    const timer = setInterval(() => {
      if (authWindow?.closed) {
        clearInterval(timer);
        window.removeEventListener('message', messageHandler);
        setIsLoading(false);
      }
    }, 1000);
  };

  return (
    <Button
      variant={variant}
      text="Continue with Google"
      startIcon={<GoogleIcon disabled={isLoading} />}
      onClick={handleGoogleLogin}
      disabled={isLoading}
      /* endIcon={isLoading ? <Spinner variant={variant} /> : null} */
    />
  );
};

export default GoogleLoginButton;
